import { handleActions } from 'redux-actions';
import { stateUpdate } from './action';
import { State } from './type';

const initialState: State = {};

const reducer = handleActions(
  {
    [String(stateUpdate)]: (state, { payload }) => {
      return {
        ...state,
        ...payload,
      };
    },
  },

  initialState,
);

export default reducer;
